import { Header, Footer } from "../../../../../components";
import { PostEditor } from "../../../../../modules/PostEditor";

export const NewLectureInquiry = () => {
  return (
    <>
      <Header />
      <PostEditor />
      <Footer />
    </>
  );
};
